import axios from "axios";
import router from '../../../router';

export default {

    async request_for_visits(context, payload){

        const token = context.rootGetters.token;
        console.log('request for visits');

        try{
            const responseData = await axios({
                method: 'post',
                url: process.env.VUE_APP_API_ENDPOINT+'visits',
                data: {
                    term: payload.term,
                    limit: payload.limit,
                    offset: payload.offset,
                    status: payload.status,
                    get_all_visits: payload.getAllVisits
                },
                mode: 'no-cors',
                headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization' : token
                }
            })

            if(!responseData.data.success){
                context.commit('setRequestError', {message:responseData.data.message} );
            } else {
                context.commit('setRequestError', {message:''} );
                context.commit('setVisits', responseData.data.results);
            }

            return new Promise((resolve, reject) => {
                if(!responseData.data.success){
                    reject(responseData.data.message);
                } else {
                    resolve(responseData);
                }
            })

        } catch(error){
            console.log('error in request')
            context.dispatch('autoLogout', null, { root: true });
            router.replace('/login');
        }

    },

    async visit_add(context, payload){

        const token = context.rootGetters.token;
        console.log('visit add');

        try{
            const responseData = await axios({
                method: 'post',
                url: process.env.VUE_APP_API_ENDPOINT+'visit_add',
                data: {
                    first_name: payload.first_name,
                    last_name: payload.last_name,
                    company: payload.company,
                    phone: payload.phone,
                    email: payload.email,
                    website: payload.website
                },
                mode: 'no-cors',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    'Authorization' : token
                }
            });

            if(!responseData.data.success){
                context.commit('setRequestError', {message:responseData.data.message} );
            } else {
                context.commit('setRequestError', {message:''} );
                context.commit('setCurrentVisitId', { flvis_id:responseData.data.flvis_id });
                context.commit('setCurrentVisitPerson', {
                    flvisp_id: responseData.data.person.flvisp_id,
                    flvisp_first_name: responseData.data.person.flvisp_first_name,
                    flvisp_last_name: responseData.data.person.flvisp_last_name,
                    flvisp_company: responseData.data.person.flvisp_company,
                    flvisp_email: responseData.data.person.flvisp_email,
                    flvisp_phone: responseData.data.person.flvisp_phone,
                    flvisp_website: responseData.data.person.flvisp_website,
                    flvisp_images: responseData.data.person.flvisp_images });

            }

        } catch(error){
            console.log('error in request')
            context.dispatch('autoLogout', null, { root: true });
            router.replace('/login');
        }

    },

    async items_search(context, payload){
        const token = context.rootGetters.token;
        console.log('items search');

        try{

            const responseData = await axios({
                method: 'post',
                url: process.env.VUE_APP_API_ENDPOINT+'items_search',
                data: {
                    searchtext: payload.search_term,
                    limit: payload.limit,
                    offset: payload.offset
                },
                mode: 'no-cors',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    'Authorization' : token
                }
            });

            if(!responseData.data.success){
                context.commit('setRequestError', {message:responseData.data.message} );
            } else {
                context.commit('setRequestError', {message:''} );
                context.commit('setItemsOfSearch', responseData.data.products );
            }

        } catch(error){
            console.log('error in request')
            context.dispatch('autoLogout', null, { root: true });
            router.replace('/login');
        }
    },

    async visit_add_item(context, payload){

        const token = context.rootGetters.token;
        console.log('visit add item');

        try{

            const responseData = await axios({
                method: 'post',
                url: process.env.VUE_APP_API_ENDPOINT+'visit_add_item',
                data: {
                    flvis_id: payload.flvis_id,
                    flvisi_type: payload.flvisi_type, // product
                    pitem_id: payload.pitem_id,
                    inv_id: payload.inv_id,
                    options: payload.options,
                    options_details: payload.options_details,
                    flvisi_notes: payload.flvisi_notes,
                    conn_id: payload.conn_id,
                },
                mode: 'no-cors',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    'Authorization' : token
                }
            });

            if(!responseData.data.success){
                context.commit('setRequestError', {message:responseData.data.message} );
            } else {
                context.commit('setRequestError', {message:''} );
                context.commit('insertedItemId', responseData.data.flvisi_id);
            }

            return new Promise((resolve, reject) => {
                if(!responseData.data.success){
                    reject(responseData.data.message);
                } else {
                    resolve(responseData);
                }
            })

        } catch(error){
            console.log('error in request')
            context.dispatch('autoLogout', null, { root: true });
            router.replace('/login');
        }


    },

    async visit_edit_item(context, payload){

        const token = context.rootGetters.token;
        console.log('visit edit item');

        try{

            const responseData = await axios({
                method: 'put',
                url: process.env.VUE_APP_API_ENDPOINT+'visit_edit_item',
                data: {
                    flvisi_id: payload.flvisi_id,
                    flvis_id: payload.flvis_id,
                    flvisi_type: payload.flvisi_type, // product
                    pitem_id: payload.pitem_id,
                    inv_id: payload.inv_id,
                    options: payload.options,
                    options_details: payload.options_details,
                    flvisi_notes: payload.flvisi_notes,
                    conn_id: payload.conn_id,
                },
                mode: 'no-cors',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    'Authorization' : token
                }
            });

            if(!responseData.data.success){
                context.commit('setRequestError', {message:responseData.data.message} );
            } else {
                context.commit('setRequestError', {message:''} );
                context.commit('insertedItemId', responseData.data.flvisi_id);
            }

        } catch(error){
            console.log('error in request')
            context.dispatch('autoLogout', null, { root: true });
            router.replace('/login');
        }


    },

    async visit_delete_item(context, payload){

        const token = context.rootGetters.token;
        console.log('visit delete item '+payload.flvisi_id);

        try{

            const responseData = await axios({
                method: 'get',
                url: process.env.VUE_APP_API_ENDPOINT+'visit_delete_item/'+payload.flvisi_id,
                mode: 'no-cors',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    'Authorization' : token
                }
            });

            if(!responseData.data.success){
                context.commit('setRequestError', {message:responseData.data.message} );
            } else {
                context.commit('setRequestError', {message:''} );
            }

        } catch(error){
            console.log('error in request')
            context.dispatch('autoLogout', null, { root: true });
            router.replace('/login');
        }

    },

    async end_visit(context, payload){

        const token = context.rootGetters.token;
        console.log('end visit');

        try{

            const responseData = await axios({
                method: 'put',
                url: process.env.VUE_APP_API_ENDPOINT+'visit_end',
                data: {
                    flvis_id: payload.flvis_id,
                    flvis_showroom_id: payload.flvis_showroom_id,
                    flvis_notes: payload.flvis_notes,
                    flvis_address: payload.flvis_address,
                    option_value: payload.option_value
                },
                mode: 'no-cors',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    'Authorization' : token
                }
            });

            if(!responseData.data.success){
                context.commit('setRequestError', {message:responseData.data.message} );
            } else {
                context.commit('setRequestError', {message:''} );
            }

        } catch(error){
            console.log('error in request')
            context.dispatch('autoLogout', null, { root: true });
            router.replace('/login');
        }

    },

    async item_scan(context, payload){

        const token = context.rootGetters.token;
        console.log('identify item from code');

        try{
            const responseData = await axios({
                method: 'post',
                url: process.env.VUE_APP_API_ENDPOINT+'items_scan',
                data: {
                    code: payload.code,
                },
                mode: 'no-cors',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    'Authorization' : token
                }
            });

            if(!responseData.data.success){
                context.commit('setRequestError', {message:responseData.data.message} );
            } else {
                context.commit('setRequestError', {message:''} );
                context.commit('setItemOfScan', {product: responseData.data.product,inventory:responseData.data.inventory} );
            }

        } catch(error){
            console.log('error in request')
            context.dispatch('autoLogout', null, { root: true });
            router.replace('/login');
        }

    },

    async visit_add_image(context, payload){
        const token = context.rootGetters.token;
        console.log('visit add image');

        try{
            const responseData = await axios({
                method: 'post',
                url: process.env.VUE_APP_API_ENDPOINT+'visit_add_image',
                data: {
                    image_data: payload.image_data,
                },
                mode: 'no-cors',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    'Authorization' : token
                }
            });

            if(!responseData.data.success){
                context.commit('setRequestError', {message:responseData.data.message} );
            } else {
                context.commit('setRequestError', {message:''} );
                context.commit('setCurrentVisitId', { flvis_id:responseData.data.flvis_id });
                context.commit('setCurrentVisitPerson', {
                    flvisp_id: responseData.data.person.flvisp_id,
                    flvisp_first_name: responseData.data.person.flvisp_first_name,
                    flvisp_last_name: responseData.data.person.flvisp_last_name,
                    flvisp_company: responseData.data.person.flvisp_company,
                    flvisp_email: responseData.data.person.flvisp_email,
                    flvisp_phone: responseData.data.person.flvisp_phone,
                    flvisp_website: responseData.data.person.flvisp_website,
                    flvisp_images: responseData.data.person.flvisp_images });

            }

        } catch(error){
            console.log('error in request')
            context.dispatch('autoLogout', null, { root: true });
            router.replace('/login');
        }
    },

    async visit_delete_image(context, payload){
        const token = context.rootGetters.token;
        console.log('visit add image');

        try{
            const responseData = await axios({
                method: 'post',
                url: process.env.VUE_APP_API_ENDPOINT+'visit_delete_image',
                data: {
                    flvisp_id: payload.flvisp_id,
                    image_index: payload.image_index
                },
                mode: 'no-cors',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    'Authorization' : token
                }
            });

            if(!responseData.data.success){
                context.commit('setRequestError', {message:responseData.data.message} );
            } else {
                context.commit('setRequestError', {message:''} );
                context.commit('setCurrentVisitPerson', {
                    flvisp_id: responseData.data.person.flvisp_id,
                    flvisp_first_name: responseData.data.person.flvisp_first_name,
                    flvisp_last_name: responseData.data.person.flvisp_last_name,
                    flvisp_company: responseData.data.person.flvisp_company,
                    flvisp_email: responseData.data.person.flvisp_email,
                    flvisp_phone: responseData.data.person.flvisp_phone,
                    flvisp_website: responseData.data.person.flvisp_website,
                    flvisp_images: responseData.data.person.flvisp_images });
            }

        } catch(error){
            console.log('error in request')
            context.dispatch('autoLogout', null, { root: true });
            router.replace('/login');
        }
    },

    async visit_edit_person(context, payload){
        const token = context.rootGetters.token;
        console.log('visit edit person');

        try{
            const responseData = await axios({
                method: 'put',
                url: process.env.VUE_APP_API_ENDPOINT+'visit_edit_person',
                data: {
                    flvisp_id: payload.flvisp_id,
                    flvisp_company: payload.flvisp_company,
                    flvisp_first_name: payload.flvisp_first_name,
                    flvisp_last_name: payload.flvisp_last_name,
                    flvisp_phone: payload.flvisp_phone,
                    flvisp_email: payload.flvisp_email,
                    flvisp_website: payload.flvisp_website,
                    image_data: payload.image_data,
                },
                mode: 'no-cors',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    'Authorization' : token
                }
            });

            if(!responseData.data.success){
                context.commit('setRequestError', {message:responseData.data.message} );
            } else {
                context.commit('setRequestError', {message:''} );
                context.commit('setCurrentVisitPerson', {
                    flvisp_id: responseData.data.person.flvisp_id,
                    flvisp_first_name: responseData.data.person.flvisp_first_name,
                    flvisp_last_name: responseData.data.person.flvisp_last_name,
                    flvisp_company: responseData.data.person.flvisp_company,
                    flvisp_email: responseData.data.person.flvisp_email,
                    flvisp_phone: responseData.data.person.flvisp_phone,
                    flvisp_website: responseData.data.person.flvisp_website,
                    flvisp_images: responseData.data.person.flvisp_images });

            }

        } catch(error){
            console.log('error in request')
            context.dispatch('autoLogout', null, { root: true });
            router.replace('/login');
        }
    }

}